import { createContext } from 'react'
//All Auction details
const customContext = createContext()

export default customContext
